<template>
  <div id="content-wrapper">
    <b-form-group class="border-bottom-form">
      <div class="d-flex">
        <div class="flex-1-0">
          <b-form-input
            v-if="false"
            @keyup.enter="layDanhSachNhomChucVu"
            id="filterBy"
            placeholder="Nhập từ khóa tìm kiếm"
            required
            type="text"
            v-model="requestInformation.filterBy"
          />
        </div>
        <div class="ml-1">
          <base-button
            button="Tìm kiếm"
            @click="layDanhSachNhomChucVu()"
            v-if="false"
          />
          <base-button
            @click="openImport"
            button="Import"
            variant="info"
            v-if="hasPermissionUser(PERMISSION_NAME.IMPORT.IMPORT_NHOM_CHUC_VU)"
          />
          <base-button
            class="btn btn-blue"
            :disabled="isLoadingExport"
            @click="openExport"
            variant="info"
            v-if="hasPermissionUser(PERMISSION_NAME.IMPORT.EXPORT_NHOM_CHUC_VU)"
            button="Export"
          >
          </base-button>
          <base-button
            button="Thêm mới"
            @click="openCreate"
            v-if="hasPermissionUser(PERMISSION_NAME.NHOM_CHUC_VU.THEM)"
          />
        </div>
      </div>
    </b-form-group>
    <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
    <DataTable
      :loading="isLoadingTable"
      :value="items"
      dataKey="id"
      class="p-datatable-customers"
    >
      <template #empty
        ><div class="text-center">Không có dữ liệu</div></template
      >
      <template #loading
        ><div class="text-center">Đang tải dữ liệu ...</div>
      </template>
      <Column
        field="id"
        dataKey="id"
        headerStyle="width: 40px"
        headerClass="p-2"
        header="STT"
        bodyStyle="text-align: center"
      >
        <template #body="slotProps">
          <span>{{
            (requestInformation.pageIndex - 1) * requestInformation.pageSize +
            slotProps.index +
            1
          }}</span>
        </template> </Column
      ><Column
        filterMatchMode="custom"
        field="maNhom"
        header="Mã nhóm chức vụ"
        headerStyle="width: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestInformation.MaNhomFilter"
            @change="layDanhSachNhomChucVu"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.maNhom }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="tenNhom"
        header="Tên nhóm chức vụ"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestInformation.TenNhomFilter"
            @change="layDanhSachNhomChucVu"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.tenNhom }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="thuTu"
        header="Thứ tự"
        headerStyle="width: 150px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestInformation.ThuTuFilter"
            @change="layDanhSachNhomChucVu"
          />
        </template>
        <template #body="slotProps">
          <div class="text-center">
            <span>{{ slotProps.data.thuTu }}</span>
          </div>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="thaoTac"
        header="Thao tác"
        headerStyle="width: 100px"
        v-if="
          hasPermissionUser(PERMISSION_NAME.NHOM_CHUC_VU.SUA) ||
          hasPermissionUser(PERMISSION_NAME.NHOM_CHUC_VU.XOA)
        "
      >
        <template #body="slotProps">
          <div class="text-center">
            <font-awesome-icon
              icon="edit"
              v-b-popover.hover.top="'Cập nhật nhóm chức vụ'"
              v-if="hasPermissionUser(PERMISSION_NAME.NHOM_CHUC_VU.SUA)"
              class="cursor-pointer color-red"
              @click="openEdit(slotProps.data)"
            />
            <font-awesome-icon
              icon="trash-alt"
              v-b-popover.hover.top="'Xóa nhóm chức vụ'"
              v-if="hasPermissionUser(PERMISSION_NAME.NHOM_CHUC_VU.XOA)"
              class="cursor-pointer color-red ml-2"
              @click="openDelete(slotProps.data)"
            />
          </div>
        </template>
      </Column>
    </DataTable>
    <BasePagination
      class="mt-3"
      :current-page="requestInformation.pageIndex"
      :total-pages="totalPages"
      :total-rows="totalRows"
      @changeNum="onChangeNum($event)"
      @changePages="onChangePages($event)"
    />

    <ModalCapNhatNhomChucVu
      :data="nhomChucVuDaChon"
      :is-edit.sync="isEdit"
      @hidden="isEdit = false"
      @refreshData="layDanhSachNhomChucVu()"
      ref="modalCapNhatNhomChucVu"
    />
    <ModalConfirm
      :title="(nhomChucVuDaChon || {}).tenNhom"
      @confirmed="xoaHeThong"
    />
    <ModalUploadImportFile
      ref="modalImport"
      :dataType="'NhomChucVu'"
      :title="'Nhóm chức vụ'"
      @refreshData="layDanhSachNhomChucVu"
    />
  </div>
</template>

<script>
import ModalCapNhatNhomChucVu from "./modalCapNhatNhomChucVu";
import ModalConfirm from "@/components/modal/ModalConfirm";
import ModalUploadImportFile from "@/components/modal/ModalUploadImportFile";
import {
  NO_RESULTS_TEXT,
  ROUTE_NAME,
  PERMISSION_NAME,
} from "@/constants/constants";
import { mapGetters } from "vuex";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
import BasePagination from "@/components/common/BasePagination";
import { hasPermissionUser } from "@/utils/permissionUtils";

export default {
  name: "DanhSachChucVu",
  components: {
    ModalCapNhatNhomChucVu,
    ModalConfirm,
    BasePagination,
    ModalUploadImportFile,
  },
  data() {
    return {
      isLoadingExport: false,
      PERMISSION_NAME,
      isLoadingTable: true,
      ROUTE_NAME: ROUTE_NAME,
      NO_RESULTS_TEXT: NO_RESULTS_TEXT,
      requestInformation: {
        filterBy: "",
        pageSize: 10,
        pageIndex: 1,
      },
      totalPages: 0,
      totalRows: 0,
      sortableOptions: { chosenClass: "is-selected" },
      nhomChucVuDaChon: {},
      isEdit: false,
      items: [],
      openModalDelete: false,
    };
  },
  created() {
    this.layDanhSachNhomChucVu();
  },
  computed: {
    ...mapGetters({
      danhSachNhomChucVu: "nhomChucVu/danhSachNhomChucVuPaging",
    }),
    hasPageData() {
      return !_isEmpty(this.danhSachNhomChucVu.items);
    },
  },
  methods: {
    hasPermissionUser,
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachApp();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachApp();
    },
    layDanhSachNhomChucVu() {
      this.isLoadingTable = true;
      this.$store
        .dispatch(
          "nhomChucVu/layDanhSachNhomChucVuPaging",
          this.requestInformation
        )
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    openCreate() {
      this.isEdit = false;
      this.$refs["modalCapNhatNhomChucVu"].$refs.modalCapNhatNhomChucVu.show();
    },
    openImport() {
      this.$refs["modalImport"].showModal();
    },
    openExport() {
      let typeExport = "NhomChucVu";
      this.isLoadingExport = true;
      this.$store
        .dispatch("importService/exportData", {
          type: typeExport,
          searchRequest: this.requestInformation,
        })
        .then((res) => {
          this.isLoadingExport = false;
          this.$toasted.global.showSuccessMessage({
            message: "Export thành công",
          });
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Export${typeExport}.xlsx`);
          document.body.appendChild(link);
          link.click();
        });
    },
    openEdit(item) {
      this.nhomChucVuDaChon = item;
      console.log(item);
      this.isEdit = true;
      this.$refs["modalCapNhatNhomChucVu"].$refs.modalCapNhatNhomChucVu.show();
    },
    openDelete(item) {
      this.nhomChucVuDaChon = item;
      this.$bvModal.show("modal-confirm");
    },
    xoaHeThong(confirm) {
      if (confirm) {
        this.$store.dispatch("nhomChucVu/xoaNhomChucVu", {
          data: { id: this.nhomChucVuDaChon.id },
          onSuccess: this.onSuccess,
        });
        this.$bvModal.hide("modal-confirm");
      }
    },
    onSuccess() {
      this.layDanhSachNhomChucVu();
    },
    capNhatThuTuNhomChucVu() {
      let listUpdate = [];
      this.items.forEach(function (item, index) {
        listUpdate.push({ Id: item.id, ThuTu: index + 1 });
      });
      let payload = new FormData();
      payload.append("arrangeRequest", JSON.stringify(listUpdate));
      this.$store.dispatch("nhomChucVu/capNhatThuTu", {
        data: payload,
        // onSuccess: null
      });
    },
    layDanhSachNhomChucVuNoiBo(danhSachNhomChucVu) {
      if (_isEmpty(danhSachNhomChucVu.items)) {
        return [];
      }
      return danhSachNhomChucVu.items.map((item, index) => {
        return {
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          chucVu: item.chucVu,
          tenNhom: item.tenNhom,
          maNhom: item.maNhom,
          id: item.id,
          thaoTac: null,
          thuTu: item.thuTu,
        };
      });
    },
  },
  watch: {
    danhSachNhomChucVu: {
      handler() {
        this.items = this.layDanhSachNhomChucVuNoiBo(this.danhSachNhomChucVu);
        this.totalPages = this.danhSachNhomChucVu.totalPage;
        this.totalRows = _isNil(this.danhSachNhomChucVu.totalCount)
          ? 0
          : this.danhSachNhomChucVu.totalCount;
      },
    },
  },
};
</script>
